import React, { useEffect, useLayoutEffect } from 'react';
import moment from 'moment-timezone';
import { Provider } from 'react-redux';
import 'react-placeholder/lib/reactPlaceholder.css';
import { CssBaseline, ThemeProvider } from '@material-ui/core';
import CookieBot from 'react-cookiebot';
import 'wicg-inert';

import { AppContent } from 'app/components/AppContent';
import { AppMainNotification } from 'app/components/AppMainNotification';
import store from 'app/store';
import { createMyTheme } from 'app/styles/createMyTheme';
import { DocumentHead } from 'app/components/DocumentHead';
import { isNewCookiesStyle, cookieBotIdReact } from 'app/services/env.service';
import isBot from 'app/shared/helpers/isBot';
import { isPrerendering } from 'app/shared/helpers/isPrerendering';

moment.tz.setDefault('Europe/Warsaw');
const theme = createMyTheme();

const App = () => {
  useEffect(() => {
    const root = document.querySelector('#root') as HTMLElement;
    const body = document.querySelector('body') as HTMLElement;

    const config = { attributes: true };

    const callback = (mutationsList: MutationRecord[]) => {
      mutationsList.forEach((mutation) => {
        if (
          mutation.type === 'attributes' &&
          mutation.attributeName === 'style'
        ) {
          body.style.overflow = root.style.overflow;
        }
      });
    };

    try {
      const observer = new MutationObserver(callback);
      observer.observe(root, config);
    } catch (e) {
      console.warn('MutationObserver not supported');
    }

    if (isBot()) {
      return;
    }

    void import('app/shared/helpers/addGlobalScripts')
      .then(({ addGlobalScripts }) => {
        addGlobalScripts();
      })
      .catch(() => {
        console.warn('addGlobalScripts failed to load');
      });
  }, []);

  useLayoutEffect(() => {
    const removePrerenderStyles = () => {
      const jssStyles = document.querySelectorAll('#jss-server-side');

      jssStyles.forEach((style) => {
        if (style.parentNode) {
          style.parentNode.removeChild(style);
        }
      });
    };

    removePrerenderStyles();
  }, []);

  return (
    <Provider store={store}>
      <ThemeProvider theme={theme}>
        <DocumentHead />
        <CssBaseline />
        {isNewCookiesStyle && cookieBotIdReact && !isPrerendering && (
          <CookieBot domainGroupId={cookieBotIdReact} />
        )}
        <AppContent />
        <AppMainNotification />
      </ThemeProvider>
    </Provider>
  );
};

export default App;
